import { CreateDossierInput } from "@/entities/dossier";
import { Reikwijdte } from "@/entities/dossier-details";
import { z } from "zod";
import { applyReikwijdteRefine, dossierDetailsBaseFields } from "./dossier-details-schema";

export const nieuwDossierSchema = z
    .object({
        ...dossierDetailsBaseFields,
        spoorwebNr: z.string(),
    })
    .superRefine(applyReikwijdteRefine);

export type NieuwDossierFormValues = z.infer<typeof nieuwDossierSchema>;

export function getDefaultValues(
    defaultReikwijdte: Reikwijdte,
    ogSpoorwebId?: string,
    initialTrajecten: NieuwDossierFormValues["trajecten"] = []
): NieuwDossierFormValues {
    return {
        // Always choose Trajecten when an OG is selected
        reikwijdte: ogSpoorwebId ? Reikwijdte.Trajecten : defaultReikwijdte,
        spoorwebNr: ogSpoorwebId ?? "",
        omschrijving: "",
        omschrijvingExtraContext: "",
        stations: [],
        trajecten: initialTrajecten,
    };
}

export function buildCreateDossierInput(values: NieuwDossierFormValues): CreateDossierInput {
    const common = {
        omschrijving: values.omschrijving,
        omschrijvingExtraContext: values.omschrijvingExtraContext,
        startDatumTijd: new Date().toISOString(),
        ...(values.spoorwebNr ? { spoorwebNummer: values.spoorwebNr } : {}),
    };

    if (values.reikwijdte === Reikwijdte.Stations) {
        return { reikwijdte: "stations", stations: values.stations, ...common };
    }
    if (values.reikwijdte === Reikwijdte.Trajecten) {
        return { reikwijdte: "trajecten", trajecten: values.trajecten, ...common };
    }
    return { reikwijdte: "landelijk", ...common };
}
